import { render, staticRenderFns } from "./MonthlyDeferredSales.vue?vue&type=template&id=c2acfbb6&lang=pug"
import script from "./MonthlyDeferredSales.vue?vue&type=script&lang=js"
export * from "./MonthlyDeferredSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports